import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { GlobalActions } from '../global/global.actions';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

@Injectable()
export class GlobalEffects {
  actions = inject(Actions);
  store = inject(Store);
  private _snackBar = inject(MatSnackBar);
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  showMessage$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(GlobalActions.setMessage),
        tap(({ infoMessage }) => {
          this._snackBar.open(infoMessage.message, 'Close', {
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: [`${infoMessage.type}-snackbar`],
            duration: 4000,
          });
        })
      ),
    { dispatch: false }
  );
}
